<!--<div class="row">
  <div class="col s12 center">
    <div class="preloader-wrapper active">
      <div class="spinner-layer spinner-blue-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<div class="row">
<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
</div>
 
